import { StorageAddonModal } from "../StorageAddonModal";
import { TTierKey } from "MVVM/Views/Pricing/Components/PricingCards/types";
import { EPriceTabView } from "MVVM/@types";

interface UnifiedUpgradeModalProps {
  featureName?: string;
  upgradeAction?: string;
  requiredTierKey?: TTierKey;
  featureDescription?: string;
  analyticsSource: string;
  initialPlan?: string;
  initialBillingPeriod?: EPriceTabView;
  showDiscordBotCta?: boolean;
  onClose: () => void;
}

export const UnifiedUpgradeModal = ({
  featureName,
  upgradeAction,
  requiredTierKey,
  featureDescription,
  analyticsSource,
  initialPlan,
  initialBillingPeriod,
  showDiscordBotCta,
  onClose,
}: UnifiedUpgradeModalProps) => {
  const paywallBanner =
    featureName && upgradeAction && requiredTierKey
      ? {
          featureName,
          upgradeAction,
          requiredTierKey,
          description: featureDescription,
        }
      : undefined;

  return (
    <StorageAddonModal
      onClose={onClose}
      analyticsSource={analyticsSource}
      initialPlan={initialPlan ?? requiredTierKey}
      initialBillingPeriod={initialBillingPeriod}
      paywallBanner={paywallBanner}
      showDiscordBotCta={showDiscordBotCta}
    />
  );
};
